<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>报名缴费</p>
      </div>
      <div class="right"></div>
    </div>
    <div class="main-wrap">
      <div class="student-info-wrap">
        <p class="title">学员信息</p>
        <div class="p1">
          <div class="content">
            <span class="name">{{ studentData.name }}</span>
            <div
              class="mobile"
              v-if="studentData.mobile && studentData.area_code"
            >
              {{ "+" + studentData.area_code }} {{ studentData.mobile }}
            </div>
            <div class="phone-style" v-if="!studentData.mobile">
              <div class="phone-style-left"></div>
              <div class="phone-style-right">
                <select-region-phone-number
                  @change="areaCode"
                  :areaCode="mySreaCodePhone.code"
                >
                  <div class="mwow-green curp">
                    <span
                      >{{ "+" + mySreaCodePhone.code }}
                      <i class="el-icon-arrow-down"></i
                    ></span>
                  </div>
                </select-region-phone-number>
              </div>
              <el-input
                size="mini"
                class="drawer_input"
                v-model="mobile"
                type="del"
                placeholder="请输入手机号码"
                :maxlength="maxNum"
              >
              </el-input>
            </div>
          </div>
          <div class="superupper" v-show="showExceeddialog">
            累计超上&nbsp; <span class="mwow-red">{{ totalExceedNumber }}</span
            >课时
            <span>
              <el-popover
                placement="top"
                width="190"
                popper-class="followuppopover"
                trigger="hover"
              >
                <p class="tipck">
                  <span v-for="item in totalExceedList" :key="item.course_id">
                    {{
                      `【${item.course.title}】超上${item.exceed_number}课时；`
                    }}<br />
                  </span>
                  开启：购买课程后会自动补扣；<br />
                  关闭：购课完成后可在订单详情页面 一键补扣，及查看超上详情；
                </p>
                <div class="question cu-po" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </span>
            <span
              class="mwow-red"
              style="font-size: 12px; margin-left: 5px"
              v-if="studentExceed"
              >续费后将自动补扣</span
            >
            <div v-else class="onekey-make-up">
              <span class="mwow-button-filled lightdanger p2" @click="look"
                >查看</span
              >
              <div class="onekey-make-up-right">
                <el-checkbox v-model="checkedMake">一键补扣</el-checkbox>
                <span>
                  <el-popover
                    placement="top"
                    width="190"
                    popper-class="followuppopover"
                    trigger="hover"
                  >
                    <p class="tipck">
                      勾选后，完成缴费会自行扣除学员超上课时；<br />
                      未勾选，完成缴费则不会扣除超上课时；
                    </p>
                    <div class="question cu-po" slot="reference">
                      <div>?</div>
                    </div>
                  </el-popover>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="head-btn-wrap">
        <div class="btn">
          <package-dialog @on-change="addPackage">添加课包 +</package-dialog>
        </div>
        <div class="btn" v-if="orderCourseSwitch">
          <course-dialog @on-change="checkCourse">添加课程 +</course-dialog>
        </div>
        <div class="btn">
          <set-dialog @on-change="inputSet">
            <div class="mwow-button-filled primary">添加套餐 +</div>
          </set-dialog>
        </div>
      </div>
      <div class="table-wrap mwow-table">
        <div class="th">
          <div class="td">购买内容</div>
          <div class="td">业务形式</div>
          <div class="td">内容价格</div>
          <div class="td">购买数量</div>
          <div class="td">总价</div>
          <div class="td">赠送数量</div>
          <div class="td">直减</div>
          <div class="td">小计</div>
          <div class="td">操作</div>
        </div>
        <div class="no-data" v-if="tableData.length === 0">请选择购买内容</div>
        <div class="item" v-for="(item, index) in tableData" :key="index">
          <!-- 课程 -->
          <div v-if="item.type === 'course'">
            <div class="title">
              <p class="text">【课程】- {{ item.course_name }}</p>
              <div class="delete-btn-wrap">
                <div class="mwow-button warning" @click="handleDelete(index)">
                  删除
                </div>
              </div>
            </div>
            <div class="tr">
              <div class="td course-name">{{ item.course_name }}</div>
              <div class="td">
                <p v-if="item.business_type === 0">-</p>
                <p v-if="item.business_type === 1">新购</p>
                <p v-if="item.business_type === 2">续费</p>
                <p v-if="item.business_type === 3">拓科</p>
              </div>
              <div class="td">
                <el-select
                  v-model="item.course_spec_id"
                  @change="
                    (v) => {
                      item.quantity = Number(courseSpecObj[v].quantity);
                      item.unit_price = Number(courseSpecObj[v].unit_price);
                      item.price = Number(courseSpecObj[v].price);
                      item.sum =
                        (solveLargeNumber(courseSpecObj[v].price) -
                          solveLargeNumber(item.discount)) /
                        100;
                      solveTableTotal();
                    }
                  "
                >
                  <el-option
                    v-for="it in item.course_spec"
                    :key="it.course_spec_id"
                    :label="it.name"
                    :value="it.course_spec_id"
                  ></el-option>
                </el-select>
              </div>
              <div class="td inner-p">
                <el-input
                  v-model="item.quantity"
                  :disabled="
                    courseSpecObj[item.course_spec_id]
                      ? Number(courseSpecObj[item.course_spec_id].quantity) !==
                        1
                      : true
                  "
                  type="number"
                  @input="
                    () => {
                      item.effective_time = solveDefaultEffectTime(item); // 根据购买数量设定有效期
                    }
                  "
                  @change="
                    (v) => {
                      let n =
                        Number(item.quantity) >= 1
                          ? Number(Number(item.quantity).toFixed(2))
                          : 0;
                      item.quantity = n;
                      item.price =
                        (solveLargeNumber(n) *
                          solveLargeNumber(item.unit_price)) /
                        10000;
                      item.sum = solveSum(
                        item.unit_price,
                        item.quantity,
                        item.discount
                      );
                      solveTableTotal();
                    }
                  "
                ></el-input
                ><span class="append">课时</span>
              </div>
              <div class="td">￥{{ item.price }}</div>
              <div class="td inner-p">
                <el-input
                  v-model="item.give_quantity"
                  type="number"
                  @change="handleGiveQuantity(item)"
                ></el-input>
                <!-- <el-input
                  style="width: 45px"
                  v-model="item.give_quantity"
                  type="number"
                  @change="
                    (v) => {
                      let n = item.give_quantity
                        ? Number(Number(item.give_quantity).toFixed(2))
                        : 0;
                      item.give_quantity = n;
                    }
                  "
                ></el-input> -->
                <span class="append">课时</span>
              </div>
              <div class="td">
                <div class="tabInp">
                  <el-select
                    v-model="item.discount_type"
                    class="discount-select"
                  >
                    <el-option label="直减" :value="0"></el-option>
                    <!-- <el-option label="折扣" :value="1"></el-option> -->
                  </el-select>
                  <el-input
                    class="discount-input"
                    v-model="item.discount"
                    v-if="item.discount_type === 0"
                    type="number"
                    @input="handleDiscountInput(item)"
                    @change="handleDiscountChange(item)"
                    ><template slot="prepend">￥</template></el-input
                  >
                  <el-input
                    v-model="item.discount"
                    v-if="item.discount_type === 1"
                    type="number"
                    ><template slot="prepend">%</template></el-input
                  >
                </div>
              </div>
              <div class="td">
                <el-input v-model="item.sum" disabled
                  ><template slot="prepend"> ￥ </template></el-input
                >
              </div>
              <div class="td"></div>
            </div>
            <div class="date-wrap">
              <span class="label">课程有效期：</span>
              <el-date-picker
                v-model="item.effective_time"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="effectiveTimeOption"
              >
              </el-date-picker>
              <el-tooltip
                effect="dark"
                content="有效期根据购买数量匹配显示可更改，超过有效期的课程，会显示过期标签"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
          <!-- 套餐 -->
          <div v-if="item.type === 'set'">
            <div class="title">
              <p class="text">【套餐】- {{ item.name }}</p>
              <div class="delete-btn-wrap">
                <div class="mwow-button warning" @click="handleDelete(index)">
                  删除
                </div>
              </div>
            </div>
            <div v-for="(it, idx) in item.item" :key="idx">
              <div class="tr">
                <div class="td">{{ it.product_name }}</div>
                <div class="td">
                  <p v-if="it.business_type === 0">-</p>
                  <p v-if="it.business_type === 1">新购</p>
                  <p v-if="it.business_type === 2">续费</p>
                  <p v-if="it.business_type === 3">拓科</p>
                </div>
                <div class="td">￥{{ it.unit_price }}</div>
                <div class="td">{{ it.quantity }}课时</div>
                <div class="td">￥{{ it.subtotal }}</div>
                <div class="td inner-p">
                  <el-input
                    v-model="it.give_quantity"
                    type="number"
                    @change="handleGiveQuantitySet(it)"
                  ></el-input
                  ><span class="append">课时</span>
                </div>
                <div class="td">
                  <div class="tabInp">
                    <el-select
                      v-model="it.discount_type"
                      class="discount-select"
                    >
                      <el-option label="直减" :value="0"></el-option>
                      <!-- <el-option label="折扣" :value="1"></el-option> -->
                    </el-select>
                    <el-input
                      class="discount-input"
                      v-model="it.discount"
                      type="number"
                      v-if="it.discount_type === 0"
                      @input="handleDiscountInput(it)"
                      @change="handleDiscountSetChange(it)"
                      ><template slot="prepend">￥</template></el-input
                    >
                    <el-input
                      v-model="it.discount"
                      type="number"
                      v-if="it.discount_type === 1"
                      ><template slot="prepend">%</template></el-input
                    >
                  </div>
                </div>
                <div class="td">
                  <el-input v-model="it.sum" disabled type="number"
                    ><template slot="prepend">￥</template></el-input
                  >
                </div>
                <div class="td"></div>
              </div>
              <div class="date-wrap">
                <span class="label">课程有效期：</span>
                <el-date-picker
                  v-model="it.effective_time"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="effectiveTimeOption"
                >
                </el-date-picker>
                <el-tooltip
                  effect="dark"
                  content="有效期根据购买数量匹配显示可更改，超过有效期的课程，会显示过期标签"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sum-total-wrap" style="margin: 26px">
        <div class="price">
          应付金额：<span class="mwow-red">￥{{ tableSumPrice }}</span>
        </div>
      </div>
      <div class="block mwow-form">
        <p class="title" style="font-weight: bold">支付信息</p>
        <div class="item">
          <span class="label">付款方式：</span>
          <el-radio-group v-model="payTypeRadio" class="cashier-wrap">
            <el-radio
              border
              :label="item.key"
              v-for="item in payType.filter((it) => {
                if (it.key === 10 || it.key === 7) {
                } else {
                  return it;
                }
              })"
              :key="item.key"
              size="mini"
              :disabled="!online_pay && item.key === 999"
              class="mwow-radio"
              :class="{ 'disable-radio': !online_pay && item.key === 999 }"
            >
              {{ item.value }}
              <span
                class="open"
                v-if="!online_pay && item.key === 999"
                @click="handleOpenOnlinePay"
              >
                立即开通
              </span>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="select-type border">
          <el-radio-group v-model="selectTypeRadio">
            <el-radio border size="mini" :label="1" :key="1">
              <span>全额付款</span>
              <span class="text price-icon">
                ￥{{ Number(tableSumPrice) }}
              </span>
            </el-radio>
            <el-radio
              border
              size="mini"
              :label="2"
              :key="2"
              :class="{ stage: Number(selectTypeRadio) === 2 }"
            >
              <span> 分期付款 </span>
              <span
                v-if="Number(selectTypeRadio) === 2"
                class="text price-icon"
              >
                ￥
                <el-input
                  v-model="nowPayPrice"
                  type="number"
                  placeholder="请输入"
                  @input="handleNowPayPriceInput"
                  @blur="handleNowPayPriceBlur"
                  ref="stageRef"
                >
                </el-input>
              </span>
            </el-radio>
          </el-radio-group>

          <div v-if="Number(selectTypeRadio) === 2" class="unpay-wrap">
            <span class="text unpay"> 未付金额： </span>
            <span class="text">
              ￥{{ (Number(tableSumPrice) - Number(nowPayPrice)).toFixed(2) }}
            </span>
          </div>

          <div class="nowPay-price flex" v-if="Number(selectTypeRadio) === 1">
            现付金额：<span class="mwow-red">
              ￥{{ Number(tableSumPrice) }}</span
            >
          </div>
        </div>
      </div>
      <div class="block mwow-form">
        <p class="title" style="font-weight: bold">基本信息</p>
        <el-row>
          <el-col :span="18">
            <!-- 未开通线上支付，或者开通线上支付但支付方式不为乐沃收银，展示-->
            <div class="item" v-if="!online_pay || payTypeRadio !== 999">
              <span class="label"> 支付时间： </span>
              <span class="content">
                <el-date-picker
                  v-model="handle_time"
                  type="datetime"
                  placeholder="选择日期时间"
                  format="yyyy-MM-dd HH:mm"
                  @change="changeHandle"
                  :picker-options="disableOptions"
                >
                </el-date-picker>
              </span>
            </div>
            <div class="item" style="margin: 20px 0 5px 0">
              <span class="label" style="margin-right: 78px"
                >创建人：{{ username }}</span
              >
              <span class="label">
                <span style="color: red">*&nbsp;</span>
                业务人员：<br />
                <span style="color: #f56c6c" v-show="showBusinessPerson"
                  >请选择业务人员</span
                >
              </span>
              <div class="content belong-wrap">
                <span
                  class="tag"
                  v-for="item in staffCheckedData"
                  :key="item.staff_id"
                  >{{ item.name }}</span
                >
                <addStaffDialog
                  :originData="staffCheckedData"
                  @change="addStaffChange"
                >
                  <span class="btn">添加 +</span>
                </addStaffDialog>
              </div>
            </div>
            <div class="item">
              <span class="label">
                <span style="color: red" v-show="showStar">*</span>
                其他备注：
              </span>
              <span class="content mwow-green"
                >如订单有赠送课时、直减金额，请在下方备注说明</span
              >
            </div>
            <div class="item" style="margin: 20px 0 0 0">
              <span class="label"></span>
              <div :class="noMoney ? 'content no-money' : 'content'">
                <el-input
                  v-model="remark"
                  type="textarea"
                  placeholder="请输入描述"
                  @blur="showNoMoney"
                ></el-input>
              </div>
            </div>
            <div class="describe-info" v-show="noMoney">请输入描述信息</div>
          </el-col>
        </el-row>
      </div>
      <div class="foot-btn-wrap">
        <div class="mwow-button-filled" @click="$router.go(-1)">取消</div>
        <div
          class="mwow-button-filled success"
          @click="checkPartiallyPay"
          v-debounce="1000"
        >
          保存
        </div>
      </div>
    </div>
    <!-- 收款确认弹窗 -->
    <el-dialog
      title="收款确认"
      :visible.sync="confirmDialog"
      @close="hideConfirmDialog"
    >
      <div class="confirm-dialog">
        <div class="info-wrap">
          <p class="head" v-if="studentData.area_code && studentData.mobile">
            <span class="name">{{ studentData.name }}</span
            >{{ "+" + studentData.area_code }} {{ studentData.mobile }}
          </p>
          <p class="head" v-else>
            <span class="name">{{ studentData.name }}</span
            >{{ "+" + mySreaCodePhone.code }} {{ mobile }}
          </p>
          <div class="table">
            <div class="th">
              <div class="td">购买内容</div>
              <div class="td">购买数量</div>
              <div class="td">赠送数量</div>
              <div class="td">直减</div>
              <div class="td">课程有效期</div>
              <div class="td">小计</div>
            </div>
            <div class="item" v-for="(item, index) in tableData" :key="index">
              <div v-if="item.type === 'course'">
                <p class="title">【课程】- {{ item.course_name }}</p>
                <div class="tr">
                  <div class="td">{{ item.course_name }}</div>
                  <div class="td">{{ item.quantity }}课时</div>
                  <div class="td">{{ item.give_quantity }}课时</div>
                  <div class="td">￥{{ item.discount }}</div>
                  <div class="td">{{ item.effective_time || "-" }}</div>
                  <div class="td">￥{{ item.sum }}</div>
                </div>
              </div>
              <div v-if="item.type === 'set'">
                <p class="title">【套餐】- {{ item.name }}</p>
                <div class="tr" v-for="(it, idx) in item.item" :key="idx">
                  <div class="td">{{ it.product_name }}</div>
                  <div class="td">{{ it.quantity }}课时</div>
                  <div class="td">{{ it.give_quantity }}课时</div>
                  <div class="td">￥{{ it.discount }}</div>
                  <div class="td">{{ it.effective_time || "-" }}</div>
                  <div class="td">￥{{ it.sum }}</div>
                </div>
              </div>
            </div>
          </div>
          <p class="sum-wrap">应付金额：￥{{ tableSumPrice }}</p>
        </div>
        <div class="pay-info">
          <p>
            收款方式：<span
              class="tag"
              v-for="(item, index) in payType.filter(
                (i) => i.key === payTypeRadio
              )"
              :key="index"
              >{{ item.value }}</span
            >
          </p>
          <p>
            现付金额：<span style="color: #07d1aa; margin-right: 12px"
              >￥{{ Number(nowPayPrice).toFixed(2) }}</span
            >
            未付金额：<span style="color: #f56c6c"
              >￥{{
                (Number(tableSumPrice) - Number(nowPayPrice)).toFixed(2)
              }}</span
            >
          </p>
          <!-- <p>办理时间：</p> -->
        </div>
        <div class="warning-info">
          <i class="el-icon-warning"></i
          >请仔细核对信息，避免填写错误，提交后订单则不可修改。
        </div>
        <div class="bottom-btns">
          <div class="mwow-button-filled" @click="hideConfirmDialog">取消</div>
          <div
            class="mwow-button-filled success"
            @click="confirmSubmit"
            v-debounce="1000"
          >
            确定
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 查看超上弹框 -->
    <el-dialog
      title="补扣课时"
      :visible.sync="dialogTableVisible"
      append-to-body
      destroy-on-close
    >
      <div class="total-class mwow-yellow">
        学员共计 “{{ totalExceedNumber }}” 个超上课时。
      </div>
      <div class="superupper-class">超上课时</div>
      <el-table v-horizontal-scroll :data="dialogData" stripe>
        <el-table-column
          property="course.title"
          label="课程名称"
        ></el-table-column>
        <el-table-column property="consume_number" label="耗课数">
          <template slot-scope="scope">
            <div>
              {{ scope.row.consume_number }}
              <span class="mwow-red">
                &nbsp;(超上{{ scope.row.exceed_number }}课时)</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <div class="mwow-green cu-po" @click="goStudentList(scope.row)">
              查看
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 审批提示 -->
    <approve-tips-dialog
      :visible.sync="approveDialogVisible"
      :order-id="orderId"
    ></approve-tips-dialog>
    <el-dialog
      title="开通乐沃收银"
      :visible.sync="openOnlinePayDialog"
      @close="openOnlinePayDialog = false"
      width="380px"
    >
      <div class="dialog">
        <p class="content">请联系总部督导或客服开通乐沃收银</p>
        <div class="flex btns">
          <div class="cat-btn" @click="openOnlinePayDialog = false">
            我知道了
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 线上扫码合并弹窗 -->
    <merge-scan-type-dialog
      v-if="mergeScanTypeDialogVisible"
      @change="handleMergeScanTypeChange"
      :originData="payCodeDialogData"
    >
    </merge-scan-type-dialog>
    <!-- 学员部分付款订单确认 -->
    <el-dialog
      title="订单提示"
      :visible.sync="checkPartiallyPayDialogVisible"
      width="380px"
    >
      <div class="partially-pay-dialog">
        <div class="content">
          <p>
            学员{{ studentData.name }}已有部分付款订单{{
              checkPartiallyPayData.order_no
            }}
          </p>
          <p>
            <span style="margin-right: 10px"
              >应付金额：{{ checkPartiallyPayData.should }}元</span
            >
            <span>已付金额：{{ checkPartiallyPayData.already }}元</span>
          </p>
          <p>未完成的订单无法入账，您是否重复创建了订单？</p>
        </div>
        <div class="button-wrap">
          <div
            class="mwow-button-filled"
            @click="checkPartiallyPayDialogVisible = false"
          >
            取消
          </div>
          <div
            class="mwow-button-filled success"
            @click="
              () => {
                checkPartiallyPayDialogVisible = false;
                createOrderConfirm();
              }
            "
          >
            继续提交
          </div>
          <div
            class="mwow-button-filled primary"
            @click="toOrderDetail(checkPartiallyPayData.order_id, 'blank')"
          >
            去看看
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import approveTipsDialog from "@/components/approveTipsDialog.vue";
import courseDialog from "./courseDialog.vue";
import setDialog from "./setDialog.vue";
import packageDialog from "./packageDialog.vue";
import {
  getPayment,
  createOrder,
  checkFinishApi,
  getHuifuPaymentUrlApi,
  checkPartiallyPayOrderApi,
} from "@/api/order";
import { setDetail, studentCourseDetailApi } from "@/api/course";
import { studentExceedListApi, studentDetail } from "@/api/studyDetails";
import { switchDetailApi } from "@/api/storeManagement";
import { UserModule } from "@/store/module/user";
import addStaffDialog from "@/components/addStaffDialog.vue";
import selectRegionPhoneNumber from "@/components/selectRegionPhoneNumber.vue";
import mergeScanTypeDialog from "@/components/mergeScanTypeDialog.vue";
import { dateFormat } from "@/utils/timeFormat";

export default {
  components: {
    courseDialog,
    setDialog,
    packageDialog,
    approveTipsDialog,
    addStaffDialog,
    selectRegionPhoneNumber,
    mergeScanTypeDialog,
  },
  data() {
    return {
      mySreaCodePhone: {
        // 自己的手机区号
        checked: true,
        code: "86",
        code_id: 1,
        en_name: "China",
        name: "中国大陆",
      },
      studentData: {
        name: "",
        mobile: "",
        area_code: "",
      },
      handle_time: "", //支付时间
      disableOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      tableSumPrice: 0,
      nowPayPrice: "", // 拆分支付
      courseSpecObj: {},
      tableData: [],

      online_pay: true, // 判断是否为新旧支付方式
      priceMatchMark: true,
      confirmDialog: false,
      staffPage: 0,
      staffLoadEnd: false,
      remark: "",
      approveDialogVisible: false,
      orderId: 0,
      noMoney: false,
      studentExceed: false, // 自动补扣开关
      totalExceedNumber: "0.00", // 超上总课时数
      totalExceedList: [], // 超上课程列表
      showExceeddialog: false, //显示超上文案
      checkedMake: false, // 一键补扣开关
      dialogTableVisible: false, // 补扣课时弹框
      dialogData: [], // 补扣课时弹框列表
      studentId: 0,
      courseIds: [],
      showBusinessPerson: false, // 是否选择业务人员
      staffCheckedData: [],
      maxNum: 16,
      mobile: "",
      paymentDialogVisible: false, // 付款码弹框
      payCodeDialogData: {},
      payTypeRadio: 0, // 选中的线上还是线下
      payType: [], // 支付方式
      selectTypeRadio: 1, // 选中的全额还是分期，默认选中全额付款
      showStar: false, // 显示备注必填标识
      scanPayCodeDialogVisible: false,
      scanPayCodeDialogData: {}, // scan流程中需要的订单信息
      openOnlinePayDialog: false,
      mergeScanTypeDialogVisible: false, // 扫码合并弹窗
      effectiveTimeOption: {
        disabledDate: (date) => {
          return date.getTime() < Date.now();
        },
      },
      checkPartiallyPayDialogVisible: false, // 学员部分付款确认弹窗
      checkPartiallyPayData: {
        order_no: "",
        should: 0,
        already: 0,
        order_id: 0,
      },
    };
  },
  computed: {
    username() {
      return UserModule.userInfo.staff_name;
    },
    orderCourseSwitch() {
      return UserModule.userInfo.order_course_switch === 1;
    },
  },
  watch: {
    // 支付方式为分期付款时，自动获取焦点并选中内容
    selectTypeRadio: {
      handler(n, o) {
        if (Number(n) === 2) {
          this.$nextTick(() => {
            this.$refs["stageRef"].focus();
            this.$refs["stageRef"].select();
          });
        }
      },
    },
  },
  created() {
    this.studentId = Number(this.$route.query.id);
    // 再来一单，可能是多个课程，或一个课程
    let cid = this.$route.query.course_id;
    if (cid) {
      if (typeof cid === "object") {
        cid = cid.map((item) => {
          return Number(item);
        });
      } else {
        cid = [Number(cid)];
      }
    }
    if (this.studentId) {
      studentDetail({
        student_id: this.studentId,
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentData = {
            name: res.data.name,
            mobile: res.data.mobile,
            area_code: res.data.area_code,
          };
        }
      });
      studentExceedListApi({
        student_id: this.studentId,
      }).then((res) => {
        if (res.error_code === 0) {
          this.totalExceedNumber = res.data.total_exceed_number;
          this.totalExceedList = res.data.list;
          this.dialogData = res.data.list;
          if (res.data.total_exceed_number !== "0.00") {
            this.showExceeddialog = true;
          }
        }
      });
    } else {
      this.$message({
        type: "error",
        message: "学员id不能为空",
      });
    }

    switchDetailApi().then((res) => {
      if (res.error_code === 0) {
        this.studentExceed = res.data.student_exceed_automatic_sub === 1;
      }
    });
    getPayment().then((res) => {
      if (res.error_code === 0) {
        this.payType = res.data.list;
        // 首位添加乐沃收银项
        this.payType.unshift({
          key: 999,
          value: "乐沃收银",
        });
        if (this.payType.length > 0 && res.data.online_pay) {
          this.payTypeRadio = res.data.list[0].key;
        }
        this.online_pay = res.data.online_pay;
      }
    });
    if (cid) {
      this.inputCourse(cid);
    }
    this.todayTime(); // 默认选中当天日期时间
  },
  methods: {
    addStaffChange(val) {
      this.staffCheckedData = val;
      // 不业务人员，提示文案
      if (this.staffCheckedData.length) {
        this.showBusinessPerson = false;
      } else {
        this.showBusinessPerson = true;
      }
    },
    areaCode(data) {
      if (data) {
        this.mySreaCodePhone = data[0];
        if (
          data[0].code !== "86" &&
          data[0].code !== "852" &&
          data[0].code !== "853" &&
          data[0].code !== "886"
        ) {
          this.maxNum = 16;
          return;
        } else if (data[0].code === "852" || data[0].code === "853") {
          this.maxNum = 8;
          return;
        } else if (data[0].code === "886") {
          this.maxNum = 10;
          return;
        } else {
          this.maxNum = 11;
          return;
        }
      }
    },
    showNoMoney() {
      if (this.remark.trim() === "" && this.tableSumPrice === 0) {
        this.noMoney = true;
        return;
      } else {
        this.noMoney = false;
      }
    },
    changeHandle(e) {
      const res = e ? e.getTime() : "";
      this.todayTime(res); // 修改时间
    },
    todayTime(t) {
      if (!t) {
        const date = new Date();
        this.gethandleTime(date);
      } else {
        const date = new Date(t);
        this.gethandleTime(date);
      }
    },
    gethandleTime(date) {
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const mm = m < 10 ? "0" + m : m;
      const d = date.getDate();
      const dd = d < 10 ? "0" + d : d;
      const H = date.getHours();
      const HH = H < 10 ? "0" + H : H;
      const M = date.getMinutes();
      const MM = M < 10 ? "0" + M : M;
      const S = date.getSeconds();
      const SS = S < 10 ? "0" + S : S;
      const time = y + "-" + mm + "-" + dd + " " + HH + ":" + MM + ":" + SS;
      this.handle_time = time;
    },
    solveSum(unit_price, quantity, dec) {
      return (
        Math.ceil(
          (this.solveLargeNumber(unit_price) * this.solveLargeNumber(quantity) -
            this.solveLargeNumber(dec) * 100) /
            100
        ) / 100
      );
    },
    solveLargeNumber(v) {
      const n = String(Number(v));
      let res = 0;
      const l = String(n).split(".");
      if (l.length <= 1) {
        res = Number(n) * 100;
      } else if (l[1].length === 1) {
        res = Number(String(n).replace(/\./, "") + "0");
      } else if (l[1].length === 2) {
        res = Number(String(n).replace(/\./, ""));
      } else if (l[1].length > 2) {
        res = Math.ceil(Number(n) * 100);
      } else {
        res = Number(n) * 100;
      }
      return res;
    },
    addPackage(row) {
      this.checkCourse([
        {
          course_id: row.course.course_id,
          course_spec_id: row.spec_id,
          title: row.course.title,
        },
      ]);
    },
    checkCourse(arr) {
      const cur = [];
      this.tableData.map((item) => {
        if (item.type === "course") {
          cur.push(item.course_id);
        }
        if (item.type === "set") {
          item.item.map((it) => {
            cur.push(it.product_id);
          });
        }
      });
      const duplicate = [];
      arr.map((item) => {
        if (cur.includes(item.course_id)) {
          duplicate.push(item.title);
        }
      });
      if (duplicate.length > 0) {
        this.$message({
          type: "warning",
          message:
            "此套餐中包含已选的课程“" +
            duplicate.join("、") +
            "”，不能重复选择。",
        });
        return false;
      }
      const courseIds = [];
      const specIds = [];
      arr.map((item) => {
        if (item.course_id) {
          courseIds.push(item.course_id);
          specIds.push(item.course_spec_id || 0);
        }
      });
      this.inputCourse(courseIds, specIds);
    },
    inputCourse(cids, specIds) {
      studentCourseDetailApi({
        course_ids: cids,
        student_id: this.studentId,
      }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.list.length > 0) {
            res.data.list.map((it, idx) => {
              it.course_spec.map((item) => {
                this.courseSpecObj[item.course_spec_id] = item;
              });
              let course = {
                type: "course",
                discount_type: 0,
                discount: 0,
                give_quantity: 0,
                effective_time: "",
                course_spec: it.course_spec,
                course_name: it.course.title,
                course_id: it.course.course_id,
                business_type: it.business_type,
                course_type: it.course.course_type,
              };
              // 规格默认值
              if (specIds) {
                course.course_spec_id =
                  specIds[idx] || it.course_spec[0].course_spec_id;
                let target = it.course_spec.find((sp) => {
                  return sp.course_spec_id === course.course_spec_id;
                });
                course.quantity = Number(target.quantity);
                course.unit_price = Number(target.unit_price);
                course.sum = Number(target.price);
                course.price = Number(target.price);
              } else {
                course.course_spec_id = it.course_spec[0].course_spec_id;
                course.quantity = Number(it.course_spec[0].quantity);
                course.unit_price = Number(it.course_spec[0].unit_price);
                course.sum = Number(it.course_spec[0].price);
                course.price = Number(it.course_spec[0].price);
              }
              course.effective_time = this.solveDefaultEffectTime(course);
              this.tableData.push(course);
              if (it.course.sales_status !== 1) {
                this.$message({
                  type: "error",
                  message: "该课程已下架",
                });
                return false;
              }
            });
            this.solveTableTotal();
            // 每次加入课程，重置现付金额为tableSumPrice
            // this.nowPayPrice = this.tableSumPrice;
            this.nowPayPrice = "";
          }
        }
      });
    },
    inputSet(arr) {
      const cur = [];
      const self = [];
      let duplicate = [];
      this.tableData.map((item) => {
        if (item.type === "course") {
          cur.push(item.course_id);
        }
        if (item.type === "set") {
          item.item.map((it) => {
            cur.push(it.product_id);
          });
        }
      });
      // 与外部对比
      arr.map((item) => {
        item.item.map((it) => {
          if (cur.includes(it.product_id)) {
            duplicate.push(it.product_name);
          }
          self.push(it.product_id);
        });
      });
      // 当前批次内对比
      arr.map((item) => {
        item.item.map((it) => {
          if (self.filter((v) => v === it.product_id).length > 1) {
            duplicate.push(it.product_name);
          }
        });
      });
      duplicate = [...new Set(duplicate)];
      if (duplicate.length > 0) {
        this.$message({
          type: "warning",
          message: `此套餐中包含已选的课程“${duplicate.join(
            "、"
          )}”，不能重复选择`,
        });
        return false;
      }
      const requests = arr.map((item) => {
        if (item.combo_product_id) {
          return setDetail({ combo_product_id: item.combo_product_id }).then(
            (res) => {
              if (res.error_code === 0) {
                const items = [];
                res.data.item.map((it) => {
                  items.push({
                    option_id: it.item_id,
                    product_id: it.product_id,
                    product_name: it.product_name,
                    quantity: Number(it.quantity),
                    discount_type: 0,
                    discount: 0,
                    give_quantity: 0,
                    effective_time: "",
                    sum: Number(it.subtotal),
                    subtotal: Number(it.subtotal),
                    unit_price: Number(it.unit_price),
                    business_type: 0,
                  });
                  this.courseIds.push(it.product_id);
                });
                this.tableData.push({
                  type: "set",
                  combo_product_id: item.combo_product_id,
                  name: item.name,
                  item: items,
                });
                this.solveTableTotal();
                // 每次加入课程，重置现付金额为tableSumPrice
                // this.nowPayPrice = this.tableSumPrice;
                this.nowPayPrice = "";
              }
            }
          );
        }
      });
      Promise.all(requests).then((res) => {
        this.getStudentCourseBusiness();
      });
    },
    getStudentCourseBusiness() {
      studentCourseDetailApi({
        student_id: this.studentId,
        course_ids: this.courseIds,
      }).then((res) => {
        if (res.error_code === 0) {
          const obj = {};
          const num = [];
          res.data.list.map((item, index) => {
            obj["key" + index] = item;
            num.push(index);
          });
          this.tableData.map((item, index) => {
            if (item.item) {
              item.item.map((it, ind) => {
                if (it.product_id) {
                  for (let i = 0; i < num.length; i++) {
                    if (it.product_id === obj["key" + i].course.course_id) {
                      it.business_type = obj["key" + i].business_type;
                    }
                  }
                }
              });
            }
          });
        }
      });
    },
    // 课程赠送课时
    handleGiveQuantity(item) {
      let n = item.give_quantity
        ? Number(Number(item.give_quantity).toFixed(2))
        : 0;
      item.give_quantity = n;
      if (item.give_quantity > 0 || item.discount > 0) {
        this.showStar = true;
      } else {
        this.showStar = false;
      }
    },
    // 课程直减金额
    handleDiscountInput(item) {
      if (!item.discount) {
        item.discount = 0;
        return false;
      }
      if (/^0\d/.test(String(item.discount))) {
        item.discount = Number(item.discount);
        return false;
      }
      if (/-/.test(String(item.discount))) {
        item.discount = Math.abs(Number(item.discount));
        return false;
      }
      if (/\.\d{3}/.test(String(item.discount))) {
        item.discount = Number(item.discount).toFixed(2);
        return false;
      }
    },
    handleDiscountChange(item) {
      let sum = 0;
      if (Number(this.courseSpecObj[item.course_spec_id].quantity) === 1) {
        sum = this.solveSum(item.unit_price, item.quantity, item.discount);
      } else {
        sum =
          (this.solveLargeNumber(item.price) -
            this.solveLargeNumber(item.discount)) /
          100;
      }
      if (sum < 0) {
        this.$message({
          type: "warning",
          message: "小计不可小于0",
        });
        item.discount = 0;
        if (Number(this.courseSpecObj[item.course_spec_id].quantity) === 1) {
          sum = this.solveSum(item.unit_price, item.quantity, 0);
        } else {
          sum = item.price;
        }
        item.sum = sum;
        this.solveTableTotal();
        return false;
      }
      item.sum = sum;
      this.solveTableTotal();
      if (item.give_quantity > 0 || item.discount > 0) {
        this.showStar = true;
      } else {
        this.showStar = false;
      }
    },
    // 套餐总送课时
    handleGiveQuantitySet(item) {
      let n = item.give_quantity
        ? Number(Number(item.give_quantity).toFixed(2))
        : 0;
      item.give_quantity = n;
      if (item.give_quantity > 0 || item.discount > 0) {
        this.showStar = true;
      } else {
        this.showStar = false;
      }
    },
    // 套餐直减金额
    handleDiscountSetChange(item) {
      let sum =
        (this.solveLargeNumber(item.subtotal) -
          this.solveLargeNumber(item.discount)) /
        100;
      if (sum < 0) {
        this.$message({
          type: "warning",
          message: "小计不可小于0",
        });
        item.discount = 0;
        item.sum = item.subtotal;
        this.solveTableTotal();
        return false;
      }
      item.sum = sum;
      this.solveTableTotal();
      if (item.give_quantity > 0 || item.discount > 0) {
        this.showStar = true;
      } else {
        this.showStar = false;
      }
    },
    handleDelete(index) {
      this.tableData.splice(index, 1);
      this.solveTableTotal();
      this.courseIds = [];
    },
    solveTableTotal() {
      const table = [...this.tableData];
      let res = 0;
      table.map((row) => {
        if (row.type === "course") {
          if (Number(this.courseSpecObj[row.course_spec_id].quantity) === 1) {
            res =
              res +
              this.solveLargeNumber(row.unit_price) *
                this.solveLargeNumber(row.quantity) -
              this.solveLargeNumber(row.discount) * 100;
          } else {
            res =
              res +
              this.solveLargeNumber(row.price) * 100 -
              this.solveLargeNumber(row.discount) * 100;
          }
        }
        if (row.type === "set") {
          row.item.map((it) => {
            res =
              res +
              this.solveLargeNumber(it.subtotal) * 100 -
              this.solveLargeNumber(it.discount) * 100;
          });
        }
      });
      this.tableSumPrice = Math.ceil(res / 100) / 100;
      this.nowPayPrice = "";
    },
    handleNowPayPriceInput(v) {
      if (/\.\d{3}/.test(String(v))) {
        this.$message({
          type: "warning",
          message: "请保留两位小数",
        });
        this.nowPayPrice = Math.floor(Number(v) * 100) / 100;
        return false;
      }
    },

    handleNowPayPriceBlur() {
      if (Number(this.nowPayPrice) < 0) {
        this.$message({
          type: "warning",
          message: "分期支付时金额不能为负数",
        });
        // 异步执行，失焦与点击保存同时触发时，先判断，再异步赋值
        setTimeout(() => {
          this.nowPayPrice = "";
        }, 200);
        return false;
      }
      if (
        this.nowPayPrice !== "" &&
        Number(this.nowPayPrice) <= 0 &&
        Number(this.tableSumPrice) !== 0
      ) {
        this.$message({
          type: "warning",
          message: "分期支付时金额需大于0",
        });
        // 异步执行，失焦与点击保存同时触发时，先判断，再异步赋值
        setTimeout(() => {
          this.nowPayPrice = "";
        }, 200);
        return false;
      }
      if (
        this.nowPayPrice !== "" &&
        Number(this.tableSumPrice) <= Number(this.nowPayPrice)
      ) {
        this.$message({
          type: "warning",
          message:
            "分期付款时，现付金额应小于待付金额" + this.tableSumPrice + "元",
        });
        // 异步执行，失焦与点击保存同时触发时，先判断，再异步赋值
        setTimeout(() => {
          this.nowPayPrice = "";
        }, 200);
        return false;
      }
    },
    async checkPartiallyPay() {
      // 课程/套餐验证
      if (this.tableData.length === 0) {
        this.$message({
          type: "error",
          message: "请先添加课程或套餐",
        });
        return false;
      }
      if (this.selectTypeRadio === 2) {
        if (!this.nowPayPrice) {
          this.$message({
            type: "warning",
            message: "分期付款时，金额不能为空",
          });
          return;
        }
      }

      // 手机号码验证
      if (this.studentData.mobile === "" && this.mobile === "") {
        this.$message({
          type: "error",
          message: "请填写手机号码",
        });
        return false;
      }
      // 描述信息
      if (this.remark.trim() === "" && this.tableSumPrice === 0) {
        this.noMoney = true;
        return;
      } else {
        this.noMoney = false;
      }
      if (this.showStar && !this.remark) {
        this.noMoney = true;
        return;
      }
      let pass = true;
      let msg = "";
      if (this.nowPayPrice > this.tableSumPrice) {
        this.$message({
          type: "error",
          message: "现付金额有误",
        });
        return false;
      }
      // 业务人员验证
      if (this.staffCheckedData.length === 0) {
        this.showBusinessPerson = true;
        return;
      } else {
        this.showBusinessPerson = false;
      }
      this.tableData.map((item) => {
        if (item.type === "course") {
          if (!item.course_spec_id) {
            pass = false;
            msg = "请正确选择课程规格";
          }
          if (typeof item.quantity !== "number" || item.quantity < 0) {
            pass = false;
            msg = "请正确填写课时数量";
          }
          if (Number(item.give_quantity) < 0) {
            pass = false;
            msg = "请正确填写赠送数量";
          }
          if (Number(item.discount) < 0) {
            pass = false;
            msg = "请正确填写直减/折扣数值";
          }
          // if (!item.effective_time) {
          //   pass = false;
          //   msg = "请选择课程有效期";
          // }
          if (item.unit_price * item.quantity - item.discount < 0) {
            pass = false;
            msg = "直减/折扣输入有误";
          }
        }
        if (item.type === "set") {
          if (!item.item || item.item.length === 0) {
            pass = false;
            msg = "套餐有误";
          } else {
            item.item.map((it) => {
              if (Number(it.give_quantity) < 0) {
                pass = false;
                msg = "请正确填写赠送数量";
              }
              if (Number(it.discount) < 0) {
                pass = false;
                msg = "请正确填写直减/折扣数值";
              }
              // if (!it.effective_time) {
              //   pass = false;
              //   msg = "请选择课程有效期";
              // }
              if (it.unit_price * it.quantity - it.discount < 0) {
                pass = false;
                msg = "直减/折扣输入有误";
              }
            });
          }
        }
      });
      if (this.online_pay && !this.payTypeRadio) {
        pass = false;
        msg = "请选择支付信息";
      } else if (
        !this.online_pay &&
        (this.payTypeRadio === 999 || !this.payTypeRadio)
      ) {
        pass = false;
        msg = "请选择支付信息";
      }
      // if (!this.selectTypeRadio) {
      //   pass = false;
      //   msg = "请选择支付信息";
      // }
      if (!pass) {
        this.$message({
          type: "error",
          message: msg,
        });
        return false;
      }
      // 检查学员是否有部分付款订单
      let checkPartiallyPayRes = await checkPartiallyPayOrderApi({
        student_id: this.studentId,
      });
      if (checkPartiallyPayRes.error_code === 0) {
        if (checkPartiallyPayRes.data.order) {
          // 打开确认弹窗
          this.checkPartiallyPayDialogVisible = true;
          this.checkPartiallyPayData = {
            order_no: checkPartiallyPayRes.data.order.order_no,
            should: checkPartiallyPayRes.data.order.receivable_amount,
            already: checkPartiallyPayRes.data.order.completed_amount,
            order_id: checkPartiallyPayRes.data.order.order_id,
          };
          return false;
        }
      }
      this.createOrderConfirm();
    },
    createOrderConfirm() {
      this.confirmDialog = true;
      // 同步执行，先判断，然后再失焦内异步赋值 this.nowPayPrice
      if (Number(this.tableSumPrice) <= Number(this.nowPayPrice)) {
        return false;
      }
      // 同步执行，先判断，然后再失焦内异步赋值 this.nowPayPrice
      if (
        this.nowPayPrice !== "" &&
        Number(this.nowPayPrice) <= 0 &&
        Number(this.tableSumPrice) !== 0
      ) {
        return false;
      }
      if (this.selectTypeRadio === 1) {
        this.nowPayPrice = this.tableSumPrice;
      }
    },
    hideConfirmDialog() {
      this.nowPayPrice = "";
      this.confirmDialog = false;
    },
    paymentCodeDialogChange(v) {
      this.paymentDialogVisible = v;
      this.confirmDialog = v;
      // 异步跳转，避免 this.paymentDialogVisible 没被赋值
      setTimeout(() => {
        this.$router.replace({
          name: "orderManageDetail",
          query: {
            id: String(this.payCodeDialogData.order_id),
          },
        });
      }, 100);
    },
    confirmSubmit() {
      const params = {};
      params.student_id = Number(this.$route.query.id); // 学生 id
      params.remark = this.remark; // 描述
      const staff = [];
      this.staffCheckedData.map((item) => {
        staff.push(item.staff_id);
      });
      params.order_belong = staff; // 业务归属人
      let amount;
      if (this.selectTypeRadio === 1) {
        amount = String(this.tableSumPrice);
      } else if (this.selectTypeRadio === 2) {
        amount = String(this.nowPayPrice);
      }
      // v2.56.x ，如果是乐沃收银，支付方式默认传 7，
      params.payment_methods = [
        {
          payment_method_id:
            Number(this.payTypeRadio) === 999 ? 7 : Number(this.payTypeRadio),
          amount: amount,
        },
      ]; // 支付方式
      const course = [];
      const combo = [];
      this.tableData.map((item) => {
        if (item.type === "course") {
          course.push({
            course_id: item.course_id,
            option_id: item.course_spec_id,
            quantity: String(item.quantity),
            discount_type: item.discount_type,
            discount: String(item.discount),
            give_quantity: String(item.give_quantity),
            effective_time: item.effective_time || "",
          });
        }
        if (item.type === "set") {
          const items = [];
          item.item.map((i) => {
            items.push({
              option_id: i.option_id,
              quantity: String(i.quantity),
              discount_type: i.discount_type,
              discount: String(i.discount),
              give_quantity: String(i.give_quantity),
              effective_time: i.effective_time || "",
            });
          });
          combo.push({
            combo_product_id: item.combo_product_id,
            item: items,
          });
        }
      });
      params.course = course; // 课程
      params.combo = combo; // 套餐
      if (this.handle_time != "") {
        params.handle_time = this.handle_time;
      }
      params.student_exceed_automatic_sub = this.checkedMake ? 1 : 2;
      if (this.mobile) {
        params.student_mobile = this.mobile;
      }
      if (this.studentData.mobile === "" && this.mobile) {
        params.student_mobile = this.mobile;
      }
      if (this.studentData.mobile === "" && this.mySreaCodePhone.code) {
        params.student_area_code = this.mySreaCodePhone.code;
      }
      // 付款成功后创建订单，或者使用现金支付
      createOrder(params).then((res) => {
        if (res.error_code == 0) {
          const cour_ids = [];
          this.tableData.map((item) => {
            if (item.course_id) {
              cour_ids.push(item.course_id);
            }
          });
          this.orderId = res.data.order_id;
          if (!this.online_pay) {
            // 线下支付，会返回order_payment_id，马上查询订单支付状态
            checkFinishApi({
              order_payment_id: res.data.order_payment_id,
            }).then((cRes) => {
              if (cRes.data.approval_id > 0) {
                this.approveDialogVisible = true;
                return false;
              } else {
                // 不需要审批，直接跳转
                this.$message({
                  type: "success",
                  message:
                    Number(this.nowPayPrice) === Number(this.tableSumPrice)
                      ? "购买成功"
                      : "支付成功",
                });
                this.$router.replace({
                  name: "orderManageDetail",
                  query: {
                    id: String(this.orderId),
                  },
                });
                return false;
              }
            });
          } else {
            // 线下支付或为 0 的情况
            if (
              params.payment_methods[0].payment_method_id !== 7 ||
              (Number(this.nowPayPrice) === 0 &&
                Number(this.tableSumPrice) === 0)
            ) {
              // 现金、转账、pos机，或者应付和现付都为0时，不拉起支付
              checkFinishApi({
                order_payment_id: res.data.order_payment_id,
              }).then((cRes) => {
                if (cRes.data.approval_id > 0) {
                  this.approveDialogVisible = true;
                  return false;
                } else {
                  // 不需要审批，直接跳转
                  this.$message({
                    type: "success",
                    message:
                      Number(this.nowPayPrice) === Number(this.tableSumPrice)
                        ? "购买成功"
                        : "支付成功",
                  });
                  this.$router.replace({
                    name: "orderManageDetail",
                    query: {
                      id: String(this.orderId),
                    },
                  });
                  return false;
                }
              });
            }
            // <!-- 注释：v2.56.x，乐沃收银的付款方式，默认 method_id 传 7 -->
            // else if (params.payment_methods[0].payment_method_id === 10) {
            //   // 扫客户付款码
            //   this.scanPayCodeDialogData = {
            //     order_id: res.data.order_id,
            //     payment_methods: params.payment_methods,
            //   };
            //   this.scanPayCodeDialogVisible = true;
            // }
            // 线上支付
            else if (params.payment_methods[0].payment_method_id === 7) {
              getHuifuPaymentUrlApi({
                order_id: res.data.order_id,
                payer_amount: params.payment_methods[0].amount,
              }).then((urlRes) => {
                let courseFlat = [];
                this.tableData.map((item) => {
                  if (item.type === "course") {
                    item.amount = item.sum.toFixed(2);
                    item.product_name = item.course_name;
                    courseFlat.push(item);
                  }
                  if (item.type === "set") {
                    item.item.map((it) => {
                      it.course_id = it.product_id;
                      it.amount = it.sum.toFixed(2);
                      courseFlat.push(it);
                    });
                  }
                });
                this.payCodeDialogData = {
                  order_no: urlRes.data.order_no,
                  order_payment_id: urlRes.data.order_payment_id,
                  item: courseFlat,
                  order_id: res.data.order_id,
                  amount: params.payment_methods[0].amount,
                  efficient_time: urlRes.data.efficient_time,
                  counter_url:
                    process.env.VUE_APP_H5_HOST +
                    "/order-pay.html?a=" +
                    urlRes.data.order_no +
                    "&b=" +
                    urlRes.data.order_payment_id,
                  create_time: res.data.create_time,
                  student_name: res.data.student.name,
                  student_mobile: res.data.student.mobile,
                  payType: this.payType,
                };
                this.paymentDialogVisible = true;
                // v2.56.x 关闭收款确认窗，展示扫码窗
                this.confirmDialog = false;
                this.mergeScanTypeDialogVisible = true;
              });
            }
          }
        } else {
          this.$message({
            type: "error",
            message: "提交失败!" + res.message,
          });
        }
      });
    },
    look() {
      this.dialogTableVisible = true;
    },
    goStudentList(val) {
      const studentList = this.$router.resolve({
        name: "rollCallRecord",
        query: {
          c_id: val.course_id,
          s_name: this.studentData.name,
          ex_type: "2",
          from: "order",
        },
      });
      window.open(studentList.href, "_blank");
    },
    handleOpenOnlinePay() {
      this.openOnlinePayDialog = true;
    },
    handleMergeScanTypeChange() {
      this.mergeScanTypeDialogVisible = false;
    },
    solveDefaultEffectTime(course) {
      let buyQuantity = Number(course.quantity) || 0;
      let now = new Date();
      let endMonth = 0;
      if (course.course_type === 2) {
        // 1v1
        if (buyQuantity >= 0 && buyQuantity <= 30) {
          endMonth = 8;
        } else if (buyQuantity > 30 && buyQuantity <= 45) {
          endMonth = 12;
        } else if (buyQuantity > 45) {
          endMonth = 24;
        }
      } else if (course.course_type === 1) {
        // 1vN
        if (buyQuantity >= 0 && buyQuantity <= 45) {
          endMonth = 12;
        } else if (buyQuantity > 45 && buyQuantity <= 60) {
          endMonth = 15;
        } else if (buyQuantity > 60) {
          endMonth = 24;
        }
      }
      let resY = now.getFullYear() + Math.floor(endMonth / 12);
      let m = now.getMonth() + 1 + (endMonth % 12);
      if (m > 12) {
        resY = resY + 1;
      }
      let res = new Date(
        `${resY}/${m % 12 === 0 ? 12 : m % 12}/${now.getDate()} 00:00:00`
      );
      if (res.getDate() === now.getDate()) {
        // 不存在大小月误差
        return dateFormat("YYYY-mm-dd", res.getTime() - 24 * 60 * 60 * 1000);
      } else {
        return dateFormat(
          "YYYY-mm-dd",
          res.getTime() - res.getDate() * 24 * 60 * 60 * 1000
        );
      }
    },
    toOrderDetail(id, target) {
      if (target === "blank") {
        const url = `${window.location.origin}/#/layout/finance/order_detail?id=${id}`;
        window.open(encodeURI(url), "_blank");
      } else {
        this.$router.push({
          name: "orderManageDetail",
          query: {
            id: id,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
.main-wrap {
  padding: 14px 72px;
}
.student-info-wrap {
  border: 1px solid #d9dadb;
  border-radius: 4px;
  padding: 26px;
  color: #5c5d5e;
  margin-bottom: 20px;
  .title {
    margin-bottom: 21px;
    font-size: 14px;
    font-weight: bold;
  }
  .content {
    font-size: 16px;
    .name {
      font-weight: bold;
      padding-right: 10px;
      margin-right: 10px;
      border-right: 1px solid #e7e8ea;
    }
  }
}
.head-btn-wrap {
  margin-bottom: 20px;
  .btn {
    display: inline-block;
    margin-right: 20px;
  }
}
/deep/.table-wrap {
  .no-data {
    font-size: 14px;
    text-align: center;
    color: #5c5d5e;
    padding: 12px;
  }
  .th {
    background-color: #f2f6fa;
    font-size: 12px;
    color: #5c5d5e;
    margin-bottom: 14px;
  }
  .tr {
    color: #5c5d5e;
    font-size: 12px;
  }
  .th,
  .tr {
    display: flex;
    align-items: center;
    padding: 0 34px;
    .el-select {
      .el-input {
        max-width: 160px;
      }
    }
    .el-input {
      max-width: 100px;
      .el-input-group__prepend {
        background: #ffffff;
        padding: 0 1px 0 9px !important;
        line-height: 20px;
        & + .el-input__inner {
          border-left: 0;
          padding-left: 1px !important;
        }
      }
    }
    .td {
      flex: 1;
      width: 0;
      overflow: hidden;
      font-size: 12px;
      line-height: 24px;
      min-height: 24px;
      color: #5c5d5e;
      padding: 9px 0;
    }
    .append {
      margin: 0 6px 0 4px;
      white-space: nowrap;
    }
    .td:nth-child(1) {
    }
    .td:nth-child(2) {
    }
    .td:nth-child(3) {
    }
    .td:nth-child(4) {
      display: flex;
      align-items: center;
      .el-input {
        flex: 1;
      }
    }
    .td:nth-child(5) {
    }
    .td:nth-child(6) {
      display: flex;
      align-items: center;
      .el-input {
        flex: 1;
      }
      .append {
        width: 24px;
      }
    }
    .td:nth-child(7) {
      flex: 2;
      .tabInp {
        background-color: #fff;
        .discount-select {
          width: 80px;
        }
        .discount-input {
          width: 100px;
          &.is-disabled {
            .el-input-group__prepend {
              background-color: #f5f7fa !important;
            }
          }
        }
      }
    }
    .td:nth-child(8) {
      .el-input-group__prepend {
        background: #f5f7fa;
        cursor: not-allowed;
      }
    }
    .td:nth-child(9) {
      flex: none;
      width: 48px;
      text-align: center;
    }
  }
  .item {
    border: 1px solid #e1e5e9;
    margin-bottom: 14px;
    .title {
      padding-left: 31px;
      background: #f2f6fa;
      display: flex;
      align-items: center;
      .text {
        line-height: 42px;
        font-size: 14px;
        color: #5c5d5e;
        font-weight: bold;
        flex: 12;
      }
      .delete-btn-wrap {
        text-align: center;
        flex: 1;
      }
    }
    .tr {
      color: #5c5d5e;
      font-size: 12px;
      /deep/ .td {
        .el-input {
          width: 120px;
        }
        .el-select {
          width: 100px;
          .el-input {
            width: 100px;
          }
        }
        .el-input-group__append,
        .el-input-group__prepend {
          padding: 0 12px;
        }
      }
    }
    .date-wrap {
      padding-left: 34px;
      line-height: 42px;
      background-color: #f6fafc;
      color: #5c5d5e;
      font-size: 12px;
      i {
        color: #bebfc0;
        font-size: 14px;
        margin-left: 6px;
        cursor: pointer;
      }
    }
  }
}
.sum-total-wrap {
  color: #5c5d5e;
  text-align: right;
  &.border {
    border-top: 1px solid #e7e8ea;
    padding-top: 24px;
  }
  .price {
    display: inline-flex;
    align-items: center;
    margin-left: 36px;
    font-size: 18px;
    .text {
      font-size: 18px;
      line-height: 24px;
      font-weight: bold;
      line-height: 22px;
      font-size: 22px;
      white-space: nowrap;
    }
  }
}
.block {
  border: 1px solid #d9dadb;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 40px;
  .title {
    font-size: 14px;
    color: #5c5d5e;
    margin-bottom: 21px;
  }
  .item {
    display: flex;
    line-height: 28px;
    // margin-bottom: 12px;
    font-size: 12px;
    color: #5c5d5e;
    .label {
      min-width: 65px;
    }
    /deep/ .cashier-wrap {
      margin-right: 22px !important;
      .el-radio {
        width: 182px;
        height: 32px !important;
        margin: 0 22px 16px 0 !important;
        .open {
          color: white;
          background: #07d1aa;
          padding: 5px 9px;
          border-radius: 3px;
          font-size: 10px;
          cursor: pointer;
        }
      }
      /deep/.disable-radio {
        padding: 6px 7px 0 10px !important;
        .is-disabled {
          .el-radio__inner {
            background: none;
            border: 1px solid rgba(231, 232, 234, 1);
            &::after {
              width: 0;
              height: 0;
            }
          }
        }
        .el-radio__label {
          color: rgba(194, 195, 196, 1) !important;
        }
      }
    }
    .content {
      .red {
        color: #f56c6c;
      }
      &.error {
        .box {
          &.active {
            border: 1px solid #f56c6c !important;
          }
        }
      }
      .box {
        display: inline-block;
        margin-right: 38px;
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        padding: 0 8px;
        &.active {
          border-color: #07d1aa;
        }
        .text {
          margin: 0 8px;
        }
        .input {
          font-size: 12px;
          color: #5c5d5e;
          width: 60px;
          border: 0;
        }
      }
    }
    .belong-wrap {
      display: flex;
      .tag {
        display: inline-block;
        vertical-align: middle;
        background-color: #f6fafc;
        padding: 0 12px;
        border-radius: 4px;
        margin-right: 12px;
        white-space: nowrap;
        margin-bottom: 10px;
      }
      .btn {
        color: white !important;
        cursor: pointer;
        white-space: nowrap;
        padding: 7px 17px;
        background: #45b13b;
        border-radius: 4px;
      }
    }
  }
  .select-type {
    padding: 0 5px 0 65px;
    &.border {
      border-top: 1px solid #e7e8ea;
      padding-top: 16px;
    }
    .el-radio {
      width: 182px;
      height: 32px !important;
      margin: 0 20px 0px 0 !important;
      .price-icon {
        margin-left: 5px;
      }
    }
    /deep/.stage {
      padding: 0px 10px;
      .el-input {
        width: 72px;
        .el-input__inner {
          height: 28px !important;
          line-height: 27px !important;
          padding: 0;
          border: none;
        }
      }
    }
    .unpay-wrap {
      display: inline-block;
      .unpay {
        margin-left: 10px;
        color: rgba(92, 93, 94, 1);
      }
    }
    .nowPay-price {
      float: right;
      align-items: center;
      margin-left: 36px;
      font-size: 18px;
      color: #5c5d5e;
    }
  }
}
.foot-btn-wrap {
  text-align: left;
  margin-bottom: 12px;
  .mwow-button-filled {
    margin-right: 10px;
  }
}
.confirm-dialog {
  .info-wrap {
    .head {
      font-size: 14px;
      color: #5c5d5e;
      margin: 0 0 20px 0;
      .name {
        font-weight: bold;
        padding-right: 12px;
        margin-right: 12px;
        border-right: 1px solid #e7e8ea;
      }
    }
    .table {
      font-size: 12px;
      color: #5c5d5e;
      line-height: 28px;
      text-align: center;
      .th,
      .tr {
        display: flex;
        .td {
          flex: 1;
          width: 0;
          overflow: hidden;
          &:first-child {
            padding-left: 28px;
            text-align: left;
          }
        }
      }
      .th {
        background-color: #f2f6fa;
        margin-bottom: 10px;
        .td {
          font-weight: bold;
        }
      }
      .tr {
        border-bottom: 1px solid #e1e5e9;
        &:last-child {
          border-bottom: 0;
        }
        .td {
        }
      }
      .item {
        margin-bottom: 10px;
        border: 1px solid #e1e5e9;
        .title {
          padding-left: 28px;
          font-weight: bold;
          background: #f2f6fa;
          text-align: left;
        }
      }
    }
    .sum-wrap {
      text-align: right;
      margin: 24px 0;
      font-size: 14px;
      .red {
        color: #f56c6c;
      }
    }
  }
  .pay-info {
    border-top: 1px solid #e7e8ea;
    margin: 0 -20px;
    p {
      padding: 0 20px;
      line-height: 24px;
      margin: 8px 0;
      font-size: 14px;
      color: #5c5d5e;
      .tag {
        border-right: 1px solid #e7e8ea;
        padding-right: 8px;
        margin-right: 8px;
        &:last-child {
          border-right: 0;
        }
      }
      .red {
        color: #f56c6c;
      }
    }
  }
  .warning-info {
    line-height: 40px;
    background-color: #fff7e9;
    font-size: 12px;
    color: #ffb940;
    text-align: center;
    margin: 0 -20px 21px -20px;
    i {
      margin-right: 8px;
      font-size: 16px;
      vertical-align: middle;
    }
  }
  .bottom-btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 12px;
    }
  }
}
.describe-info {
  color: #f56c6c;
  margin-left: 70px;
}
.p1 {
  display: flex;
  align-items: center;
  .superupper {
    align-items: center;
    font-size: 16px;
    margin-left: 50px;
    display: flex;
  }
  .content {
    display: flex;
    align-items: center;
    .mobile {
      font-size: 16px;
    }
    /deep/ .phone-style {
      width: 260px;
      display: flex;
      .phone-style-right {
        cursor: pointer;
        width: 50%;
        text-align: center;
        line-height: 26px;
        border: 1px solid #e7e8ea;
        border-right: none;
        border-radius: 4px 0 0 4px;
      }
      .el-input {
        width: 100% !important;
        .el-input__inner {
          border-radius: 0 4px 4px 0 !important;
        }
        .el-input__inner:focus {
          border-color: #07d1aa !important;
        }
      }
    }
  }
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.p2 {
  margin: 0 10px;
  height: 20px !important;
  line-height: 20px !important;
  padding: 0 10px !important;
}
.total-class {
  font-size: 16px;
  margin: 10px 0 20px 10px;
}
.superupper-class {
  font-size: 16px;
  margin-bottom: 10px;
}
.course-name {
  line-height: 24px !important;
  padding: 5px 5px 5px 34px;
  width: 150px;
}
/deep/ .inner-p {
  .el-input__inner {
    padding: 0 5px !important;
  }
}
/deep/ .onekey-make-up {
  display: flex;
  align-items: center;
  .onekey-make-up-right {
    padding-left: 10px;
    border-left: 1px solid #d7d7d7;
    display: flex;
    align-items: center;
    //修改选择框的颜色
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #07d1aa !important;
      background-color: #07d1aa !important;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #07d1aa !important;
    }
    //修改选中后文本的颜色
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #07d1aa !important;
    }
  }
}
/deep/ .discount-select {
  position: relative;
  width: 75px !important;
  .el-input {
    width: 75px !important;
  }
  .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }
  &::after {
    content: "";
    width: 1px;
    background: #e7e8ea;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
/deep/ .discount-input {
  width: 80px !important;
  .el-input-group__prepend {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    background: #ffffff;
    padding: 0 2px 0 10px !important;
  }
  .el-input__inner {
    padding-left: 2px !important;
    border-left: 0;
    padding: 0 5px !important;
  }
}
/deep/ .el-form-item__error {
  margin-left: 70px;
}
/deep/ .no-money {
  .el-textarea__inner {
    border: 1px solid #f56c6c;
  }
}

.block {
  border: 1px solid #d9dadb;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 40px;
  .title {
    font-size: 14px;
    color: #5c5d5e;
    margin-bottom: 21px;
  }
  .item {
    display: flex;
    line-height: 28px;
    // margin-bottom: 12px;
    font-size: 12px;
    color: #5c5d5e;
    .label {
      min-width: 65px;
    }
    .content {
      flex: 1;
      .red {
        color: #f56c6c;
      }
      &.error {
        .box {
          &.active {
            border: 1px solid #f56c6c !important;
          }
        }
      }
      .box {
        display: inline-block;
        margin-right: 38px;
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        padding: 0 8px;
        &.active {
          border-color: #07d1aa;
        }
        .text {
          margin: 0 8px;
        }
        .input {
          font-size: 12px;
          color: #5c5d5e;
          width: 60px;
          border: 0;
        }
      }
    }
    .belong-wrap {
      .tag {
        display: inline-block;
        vertical-align: middle;
        background-color: #f6fafc;
        padding: 0 12px;
        border-radius: 4px;
        margin-right: 12px;
        white-space: nowrap;
        margin-bottom: 10px;
      }
      .btn {
        color: #07d1aa;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }
}
.dialog {
  .content {
    font-size: 14px;
    line-height: 20px;
  }
  .btns {
    padding-top: 10px;
    justify-content: flex-end;
    .cat-btn {
      font-size: 12px;
      background: #07d1aa;
      color: white;
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.green-text {
  color: #45b13b;
}
.partially-pay-dialog {
  .content {
    p {
      color: #5c5d5e;
      font-size: 14px;
      line-height: 28px;
    }
  }
  .button-wrap {
    margin-top: 24px;
    text-align: right;
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
</style>
